import React from "react";
import CustomToolTip from "../custom-tooltip/CustomTooltip.component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { regular } from "@fortawesome/fontawesome-svg-core/import.macro";
import moment from "moment";
import { replaceDynamicString } from "../../utils/helperFn";

const DocumentCardItem = ({
  t,
  populateIcon,
  data,
  timeFrameHandler,
  handleDownload,
  keySetter,
  taskType,
  eventId,
}) => {
  const timeFrameFlag = React.useMemo(() => {
    const tempEndDate = !!data.endDate
      ? data.endDate
      : moment(data.startDate).add(10, "minute");
    return !timeFrameHandler(data.startDate, tempEndDate);
  }, [data]);
  const tooltipMessage = () => {
    // message before and after schedule time
    if (moment().isBefore(data.startDate)) {
      if (data?.accessScheduleType === "CUSTOM") {
        return `${t("this_file_will_be_available_from")} ${moment(
          data.startDate
        ).format("MMM DD YYYY hh:mm A")}`;
      }
      return replaceDynamicString(
        t("this_file_will_be_available_when_task_type_starts"),
        [data.accessScheduleType === "CANDIDATE" ? t("schedule") : t(data?.accessScheduleType?.toLowerCase())]
      );
    }
    return t("this_file_is_currently_unavailable");
  };
  return (
    <div className="d-flex cm-btn-radius border border-blue-gray-100 mb-2 py-2 px-3">
      <span className="my-auto">
        {populateIcon(data.documentName.split(".")[1])}
      </span>
      <p className="my-auto pt-1 text-blue-800 cm-sm-txt fw-medium flex-grow-1 ms-1 cm-truncate-1">
        {data?.documentTitle}
      </p>
      {["VIEW_ONLY", "VIEW_DOWNLOAD"].includes(data.accessControl) &&
        !!data?.documentId &&
        timeFrameFlag ? (
        <CustomToolTip
          disableTooltip={false}
          title={
            <p className="mb-0 text-white fw-medium cm-xs-txt">
              {t("view_file")}
            </p>
          }
        >
          <a
            href={`/preview-document/${eventId}/${data.documentId}/${`${!!taskType ? keySetter[taskType] : "e"
              }`}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            <FontAwesomeIcon
              icon={regular("eye")}
              className="cm-sm-txt cm-btn-radius ms-2 text-blue-800 py-10 px-12 bg-blue-gray-50 cm-pointer"
            />
          </a>
        </CustomToolTip>
      ) : null}
      {["VIEW_DOWNLOAD"].includes(data.accessControl) && timeFrameFlag ? (
        <CustomToolTip
          disableTooltip={false}
          title={
            <p className="mb-0 text-white fw-medium cm-xs-txt">
              {t("download_file")}
            </p>
          }
        >
          <FontAwesomeIcon
            icon={regular("download")}
            onClick={() => {
              handleDownload(data.documentId, data.documentName);
            }}
            className="cm-sm-txt cm-btn-radius ms-2 text-blue-800 py-10 px-12 bg-blue-gray-50 cm-pointer"
          />
        </CustomToolTip>
      ) : null}
      {!timeFrameFlag ? (
        <CustomToolTip
          disableTooltip={false}
          title={
            <p className="mb-0 text-white fw-medium cm-xs-txt">
              {tooltipMessage()}
            </p>
          }
        >
          <FontAwesomeIcon
            icon={regular("ban")}
            className="cm-sm-txt cm-btn-radius ms-2 text-blue-gray-500 py-10 px-12 bg-blue-gray-50"
          />
        </CustomToolTip>
      ) : null}
      {["BLOCK_ACCESS"].includes(data.accessControl) && timeFrameFlag ? (
        <CustomToolTip
          disableTooltip={false}
          title={
            <p className="mb-0 text-white fw-medium cm-xs-txt">
              {t("this_file_is_currently_unavailable")}
            </p>
          }
        >
          <FontAwesomeIcon
            icon={regular("lock")}
            className="cm-sm-txt cm-btn-radius ms-2 text-blue-gray-500 py-10 px-12 bg-blue-gray-50"
          />
        </CustomToolTip>
      ) : null}
    </div>
  );
};

export default DocumentCardItem;
